import React from 'react';
import PropTypes from 'prop-types';

import { TooltipV2 } from '@motorway/motorway-storybook-cra';

import { APP_THEME } from 'Utilities/consts';
import { useCoarsePointer } from 'Utilities/helpers';

import styles from './Tooltip.module.scss';

const Tooltip = ({ children, ...props }) => {
	const isCoarsePointer = useCoarsePointer();

	return (
		<TooltipV2
			backgroundColor={styles.backgroundColor}
			borderColor={styles.borderColor}
			contentClassName={styles.tooltip}
			delayHide={100}
			extraModifiers={[
				{
					enabled: true,
					name: 'flip',
					options: {
						fallbackPlacements: ['bottom'],
					},
				},
				{
					name: 'preventOverflow',
					options: {
						enabled: true,
						padding: 12,
					},
				},
			]}
			offset={[0, 5]}
			placement="top"
			renderInPortal={!isCoarsePointer}
			theme={APP_THEME}
			trigger={isCoarsePointer ? 'click' : 'hover'}
			{...props}
		>
			{children}
		</TooltipV2>
	);
};

Tooltip.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Tooltip;
